module.exports = __webpack_public_path__ + "media/images/landscape-c2815c41f68290cde0efb14ff745d0ad.jpg";